import { FunnelIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Filter = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <FunnelIcon size={Sizes[size]} color={fill} {...rest} />;
};

Filter.displayName = 'Filter';
